/**
 * Save for later
 *
 * Moves a line out of the cart and into the wishlist: add the product, then
 * hand the removal to the theme's own remove control rather than posting to
 * /cart/change here. Horizon already owns the optimistic row animation, the
 * section re-render and the error handling for that request, and a second
 * implementation would drift from it.
 *
 * The wishlist lives in localStorage under the key otb-wishlist.js owns. That
 * script holds its copy in memory, so it is told to re-read rather than left
 * showing a stale heart on the recommendations below the cart.
 */
(() => {
  const storageKey = 'otb:wishlist-products';

  const save = (productId) => {
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      const wishlist = new Set(Array.isArray(stored) ? stored.map(String) : []);
      // Adding, never toggling: the shopper asked to keep this, and the line is
      // about to leave the cart either way.
      wishlist.add(String(productId));
      localStorage.setItem(storageKey, JSON.stringify([...wishlist]));
    } catch {
      // Storage can be unavailable in private windows. The line should still
      // leave the cart — that half the action is what the shopper can see.
    }
    document.dispatchEvent(new CustomEvent('otb:wishlist-updated'));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-otb-save-for-later]');
    if (!button) return;

    const row = button.closest('.cart-items__table-row');
    const remove = row?.querySelector('.cart-items__remove');
    if (!remove) return;

    event.preventDefault();
    save(button.dataset.productId);
    remove.click();
  });
})();
